import { areIntervalsOverlapping } from "date-fns";

// Universal's Aventura Hotel - 224860
// Loews Sapphire Falls Resort - 224873
// Universal's Cabana Bay Beach Resort - 224867
export const RENOVATION_HOTEL_IDS = [224860, 224873, 224867];
export const RENOVATION_WINDOW = {
  start: new Date('2026-10-26'),
  end: new Date('2027-04-01'),
};

export function shouldShowRenovationNotice(
  hotelId: number | string,
  dateFrom: Date | null | undefined,
  dateTo: Date | null | undefined
): boolean {
  const isRenovationHotel = RENOVATION_HOTEL_IDS.includes(Number(hotelId));

  const isRenovationPeriod =
    !!dateFrom &&
    !!dateTo &&
    areIntervalsOverlapping(
      { start: dateFrom, end: dateTo },
      RENOVATION_WINDOW,
      { inclusive: true }
    );

  return isRenovationHotel && isRenovationPeriod;
}
